import React from 'react'

function Direction2() {
  return (
<div className='direction'>
            <h1>Directions!!!</h1>
            <h4>To test it out, download the expo application and enter this link:</h4>
            <ul>
                <li>Android: 'exp://u.expo.dev/update/0f6d82f0-ac8d-409f-a3d3-34c33ed0bd50'  </li>
                <li> IOS: 'exp://u.expo.dev/update/803745c4-0a71-4b9f-929e-8b20d5a29c2f'</li>
            </ul>
        </div>
  )
}

export default Direction2